import { normalizePhone } from "@/helpers/normalizers";

type ProfileUser = {
  first_name?: string;
  last_name?: string;
  email?: string;
  mobile_no?: string;
  fk_role_id?: number | string;
  profile_name?: string;
  logo_name?: string;
};

export const getProfileFormInitialValues = (user: ProfileUser = {}) => ({
  first_name: user.first_name ?? "",
  last_name: user.last_name ?? "",
  email: user.email ?? "",
  mobile_no: normalizePhone(user.mobile_no) ?? "",
  fk_role_id: user.fk_role_id,
  profile_name: user.profile_name ?? "",
  logo_name: user.logo_name ?? "",
  profile_image: "",
  logo_image: "",
});
